<template>
  <div
    class="d-flex align-items-center min-vh-100 login-container"
    v-if="isLoadingData"
  >
    <b-container>
      <b-row class="justify-content-center">
        <b-col md="9" lg="6" class="login">
          <b-card-group>
            <b-card class="p-4 shadow-lg">
              <b-card-body class="login-box">
                <b-form>
                  <div class="text-center img-logo-cover">
                    <!-- <img src="/logo.png" alt /> -->
                    <div
                      class="imgLogo"
                      v-bind:style="[
                        logo
                          ? {
                              'background-image': 'url(' + logo + ')',
                            }
                          : {
                              'background-image': 'url(' + imgLogo + ')',
                            },
                      ]"
                    ></div>
                    <hr class="my-4" />
                  </div>
                  <InputText
                    class="my-3 login-input"
                    v-model="form.username"
                    textFloat="Email"
                    placeholder="อีเมล"
                    type="email"
                    name="email"
                    isRequired
                    :isValidate="$v.form.username.$error"
                    :v="$v.form.username"
                    @onKeyup="submitFormOnInput"
                  />
                  <InputText
                    class="my-3 login-input"
                    v-model="form.password"
                    textFloat="Password"
                    placeholder="รหัสผ่าน"
                    type="password"
                    name="password"
                    isRequired
                    :isValidate="$v.form.password.$error"
                    :v="$v.form.password"
                    @onKeyup="submitFormOnInput"
                    isShowPassword
                  />
                  <b-row class="m-2 text-center">
                    <span v-if="error != ''" class="text-danger w-100 mb-3">
                      {{ error }}
                    </span>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        type="button"
                        class="px-4 login-btn"
                        @click="checkForm"
                        :disabled="isDisable"
                        >เข้าสู่ระบบ
                        <b-spinner
                          class="align-middle w-1rem"
                          v-if="isLogin"
                        ></b-spinner
                      ></b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>

    <ModalComingSoon ref="modalComingSoon" />
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import ModalComingSoon from "@/components/modal/alert/ModalComingSoon";
import imgLogo from "@/assets/images/logo.svg";

export default {
  name: "Login",
  components: {
    InputText,
    ModalComingSoon,
  },
  data() {
    return {
      imgLogo: imgLogo,
      error: "",
      form: {
        username: "",
        password: "",
      },
      isLoading: false,
      isDisable: false,
      isLogin: false,
      isLoadingData: false,
      passwordType: "",
      adminToken: "",
      logo: "",
      favicon: "",
      fixBrandID: null,
    };
  },
  validations() {
    return {
      form: {
        username: { required, email },
        password: { required },
      },
    };
  },
  mounted: async function () {
    const MODE = process.env.VUE_APP_MODE
      ? `${process.env.VUE_APP_MODE}`
      : "DEV";
     this.fixBrandID = process.env[`VUE_APP_BASE_BRAND_ID_${MODE}`];
    await this.getLogo();
    await this.setIcon();
    this.isLoadingData = true;
  },
  created() {},
  methods: {
    async getLogo() {
      await this.axios
        .get(this.$baseUrl + `/Brand/GetAnonymous/${this.fixBrandID}`)
        .then((response) => {
          if (response.result === 1) {
            const { logo, favicon } = response.detail;
            this.logo = logo;
            this.favicon = favicon ? favicon : logo;
          }
        });
    },
    async setIcon() {
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.favicon;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      this.isDisable = true;
      this.isLogin = true;
      this.error = "";
      this.adminToken = "";
      this.axios
        .post(`${this.$baseUrl}/user/login`, this.form)
        .then((data) => {
          this.isDisable = false;
          if (data.result == 1) {
            this.adminToken = data.detail.token;
            // this.loginDOrder();

            this.$cookies.set("d-dots-prod-admin-token", this.adminToken, 60 * 60 * 24 * 30);
            this.$cookies.set(
              `${process.env.VUE_APP_MODE}-admin-token`,
              this.adminToken,
              60 * 60 * 24 * 30
            );
            this.$cookies.set(
              `${process.env.VUE_APP_MODE}-chat-agent-token`,
              this.adminToken,
              60 * 60 * 24 * 30
            );
            window.location.href = "/";
            this.isLoading = false;
            this.isDisable = false;
            this.isLogin = false;
          } else {
            this.isLoading = false;
            this.isLogin = false;
            this.error = data.message;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.isLogin = false;
          this.error = err.message;
        });
    },
    async loginDOrder() {
      var myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$dOrderAPIKey);
      // myHeaders.append("Authorization", "Bearer " + tokenData);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        username: this.form.username,
        password: this.form.password,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(this.$dOrderBaseUrl + "/Authenticate", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.result) {
            this.loginChatAgent(result.detail.token);
          } else {
            this.isLoading = false;
            this.isLogin = false;
            this.error = result.message;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.isLogin = false;
          console.log("error", error);
          this.error = error.message;
        });
    },
    loginChatAgent(tokenData) {
      var myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$chatAPIKey);
      myHeaders.append("Authorization", "Bearer " + tokenData);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        email: this.form.username,
        password: this.form.password,
        token: tokenData,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(this.$chatBaseUrl + "/user/update-token", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.result) {
            this.$cookies.set("d-dots-prod-admin-token", this.adminToken, 60 * 60 * 24 * 30);
            this.$cookies.set(
              `${process.env.VUE_APP_MODE}-admin-token`,
              this.adminToken,
              60 * 60 * 24 * 30
            );
            this.$cookies.set(
              `${process.env.VUE_APP_MODE}-chat-agent-token`,
              tokenData,
              60 * 60 * 24 * 30
            );
            window.location.href = "/";
            this.isLoading = false;
            this.isDisable = false;
            this.isLogin = false;
          } else {
            this.isLoading = false;
            this.isLogin = false;
            this.error = result.message;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.isLogin = false;
          console.log("error", error);
          this.error = error.message;
        });
    },
    submitFormOnInput: function (e) {
      if (e.keyCode === 13) {
        this.checkForm();
      }
    },
    handleShowHidePassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
  },
};
</script>

<style scoped>
.w-1rem {
  width: 1rem;
  height: 1rem;
}

.button-eye {
  position: absolute;
  right: 10px;
  top: 0.8rem;
  z-index: 6;
}
</style>
